<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-form-group :label="$t('staff') + ' ' + $t('documents')">
                    <b-input-group >
                        <div class="label-as-input">{{ isNotNullValue(form.type) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('documents_upload')">
                    <div class="d-flex" v-if="form.file_name">
                        <b-input-group>
                            <div class="label-as-input">
                                {{ isNotNullValue(form.file_name) }}
                            </div>
                        </b-input-group>
                        <div class="d-flex custom-file-upload">
                            <b-button variant="outline-secondary"
                                    @click="downloadFile()">
                                <i class="ri-eye-line" style="font-size:20px"></i>
                            </b-button>
                        </div>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('explanation')">
                    <b-input-group >
                        <div class="label-as-input">{{ isNotNullValue(form.description) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

    </div>
</template>

<script>
// Services
import StaffService from '@/services/StaffService';

export default {
    props: {
        formId: { type: [Number, String] },
        docUuid: { type: String, default: null }
    },
    data() {
        return {
            form: {
                file_name: null,
                type: null,
                description: null
            },
            formLoading: false
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            StaffService.document(id).then(res => {
                const arr = res.data.data
                this.formList = Array.isArray(arr) ? arr : [arr]
                this.filterByUuid()
            })
        },
        filterByUuid() {
            const item = this.docUuid
                        ? this.formList.find(d => d.uuid === this.docUuid)
                        : this.formList[0]

            this.form = {
                file_name: item ? item.file_name : null,
                type: item ? item.type : null,
                description: item ? item.description : null
            }
        },
        downloadFile(){
            StaffService.downloadFile(this.docUuid)
                .then(res=>{
                    const blob = new Blob([res.data], { type: res.headers['content-type'] });
                    const fileURL = window.URL.createObjectURL(blob);
                    window.open(fileURL, '_blank');
                })
                .catch(err=>this.showErrors(err,null,true))
        }
    }
}
</script>

